import { render, staticRenderFns } from "./EInvoiceGoodsTable.vue?vue&type=template&id=570908d7&scoped=true"
import script from "./EInvoiceGoodsTable.vue?vue&type=script&lang=js"
export * from "./EInvoiceGoodsTable.vue?vue&type=script&lang=js"
import style0 from "./EInvoiceGoodsTable.vue?vue&type=style&index=0&id=570908d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570908d7",
  null
  
)

export default component.exports